export const NS_TELEHEALTH_CORE = 'telehealth-core';
export const CROWDIN_DISTRIBUTION_HASH = 'e-55b8f1847490f0b920ba3b3mgk';
